import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "background-white padding30px" }
const _hoisted_2 = { class: "width1000px" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)
const _hoisted_8 = { class: "display-inline-block width40per" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "width100per margin-top20px"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)
const _hoisted_13 = { class: "width40per" }
const _hoisted_14 = {
  key: 0,
  class: "width100per position-relative"
}
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "font-size20px text-position-right" }
const _hoisted_17 = { class: "width100per position-relative  margin-top20px" }
const _hoisted_18 = { class: "display-inline-block width40per" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "height25px" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_billing_info = _resolveComponent("billing-info")
  const _component_button_tip = _resolveComponent("button-tip")
  const _component_list = _resolveComponent("list")
  const _component_activity_prop = _resolveComponent("activity-prop")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_billing_info, {
        userType: _ctx.userType,
        onBillInfoFilled: _ctx.billInfoFilled
      }, null, 8, ["userType", "onBillInfoFilled"]),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode("b", null, _toDisplayString(_ctx.info.item.length) + " " + _toDisplayString(_ctx.$wordList.Items), 1),
      _hoisted_6,
      _createVNode(_component_list, {
        headers: _ctx.listHeader,
        requestData: false,
        update: _ctx.updateToList,
        listData: _ctx.userInfoList,
        action: false,
        showCheck: false,
        showDefaultAction: []
      }, {
        NameSlot: _withCtx((data) => [
          _createTextVNode(_toDisplayString(data.scope.Name) + " ", 1),
          (['11','21'].includes(data.scope.Role))
            ? (_openBlock(), _createBlock(_component_button_tip, {
                key: 0,
                color: "#676767"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.AdditionalApp), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (data.scope.Role==='40')
            ? (_openBlock(), _createBlock(_component_button_tip, {
                key: 1,
                color: "#676767"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.PmApp), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        FeeTypeSlot: _withCtx((data) => [
          _createTextVNode(_toDisplayString(_ctx.FeeType[Number(data.scope.FeeType)]), 1)
        ]),
        RoomNameSlotHeader: _withCtx((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getSortRes(`${_ctx.userType}SubscriptionInformation`, 'RoomName')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg(`${_ctx.userType}SubscriptionInformation`, 'RoomName')
            }, null, 8, ["src"])
          ])
        ]),
        RoomNumberSlotHeader: _withCtx((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getSortRes(`${_ctx.userType}SubscriptionInformation`, 'RoomNumber')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg(`${_ctx.userType}SubscriptionInformation`, 'RoomNumber')
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["headers", "update", "listData"]),
      _hoisted_7,
      (_ctx.isAutoRenew)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.autoRenewConfigInfoComponent[_ctx.userType]), {
            key: 0,
            autoRenewInfo: _ctx.info.autoRenewInfo,
            info: _ctx.info
          }, null, 8, ["autoRenewInfo", "info"]))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.renewType.includes(_ctx.subscriptionType))
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  (_ctx.subscriptionType==='renewToMonth')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.ProperAllTextSubscriptionDuration), 1),
                        _createVNode("b", null, _toDisplayString(_ctx.info.count) + " " + _toDisplayString(_ctx.$wordList.ProperAllTextMonth), 1),
                        _hoisted_9
                      ], 64))
                    : (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.RenewTo) + " : ", 1),
                        _createVNode("b", null, _toDisplayString(_ctx.info.renewToDate), 1)
                      ])),
                  _hoisted_11
                ], 64))
              : _createCommentVNode("", true),
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              (_ctx.subscriptionType==='renewToDay')
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$wordList.RenewChooseAptNumber), 1),
                    _createVNode("b", _hoisted_16, _toDisplayString(_ctx.userInfo.length), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_17, [
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$wordList.OrderTotalPrice), 1),
                _withDirectives(_createVNode(_component_activity_prop, {
                  activity: _ctx.activity,
                  text: '$' + _ctx.info.totalPrice,
                  saveFee: _ctx.saveFee,
                  month: _ctx.info.count
                }, null, 8, ["activity", "text", "saveFee", "month"]), [
                  [_vShow, _ctx.activity.length !== 0]
                ]),
                _withDirectives(_createVNode("b", { class: "font-size20px text-position-right" }, " $" + _toDisplayString(_ctx.info.totalPrice), 513), [
                  [_vShow, _ctx.activity.length === 0]
                ])
              ])
            ])
          ], 64)),
      _hoisted_19,
      _createVNode(_component_el_checkbox, {
        class: "margin-right10px",
        modelValue: _ctx.agree,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.agree = $event))
      }, null, 8, ["modelValue"]),
      _createVNode("label", {
        style: {"font-size":"14px","cursor":"pointer"},
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.agree = !_ctx.agree)),
        innerHTML: _ctx.generateAgreementWord()
      }, null, 8, ["innerHTML"]),
      _hoisted_20,
      _createVNode(_component_cus_button, {
        type: "blue",
        disabled: !_ctx.agree,
        onClick: _ctx.pay
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isAutoRenew?_ctx.$wordList.TabelFootSubmit:_ctx.$wordList.OrderPay), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}